// extracted by mini-css-extract-plugin
export default {"main":"cod_main__9VpG+","btn":"cod_btn__z1yav"};